import { useState, useEffect } from 'react';
import { APIDeleteAccessAccount, APIPostAccessAccount } from '../../api/access/Access';
import { FaRegCopy, FaTrash } from "react-icons/fa";

export const AccountShare = ({ accessData, setAccessData, entityId, entityType, fetchAccessData }) => {
    const [ invites, setInvites ] = useState([]);
    const [ inviteEmail, setInviteEmail ] = useState('');
    const [ loading, setLoading ] = useState(false);

    useEffect(() => {
        if (accessData && accessData.length > 0) {
            setInvites(accessData);
        } else {
            setInvites([]);
        }
    }, [accessData]);


    const handleInvite = async (e) => {
        e.preventDefault();
        if (!inviteEmail) return;
        setLoading(true);
        await APIPostAccessAccount(entityId, entityType, inviteEmail);
        setInviteEmail('');
        await fetchAccessData();
        setLoading(false);
    };

    // Revoke invite
    const handleRevoke = async (inviteId) => {
        setLoading(true);
        await APIDeleteAccessAccount(inviteId);
        await fetchAccessData();
        setLoading(false);
    };

    return (
        <div className="flex flex-col gap-4">
                <h2 className="text-xl font-bold text-gray-800 mb-2">Plan teilen – Nutzer einladen</h2>
                <p className="text-gray-600 text-sm leading-relaxed mb-2">
                    Lade weitere Nutzer per E-Mail ein, um Zugriff auf diesen Plan zu gewähren. Du kannst beliebig viele Personen einladen und den Zugriff jederzeit entziehen.
                </p>
                <form onSubmit={handleInvite} className="flex gap-2 mb-4">
                    <input
                        type="email"
                        placeholder="E-Mail-Adresse eingeben"
                        value={inviteEmail}
                        onChange={e => setInviteEmail(e.target.value)}
                        className="border px-2 py-1 rounded flex-1"
                        required
                    />
                    <button
                        type="submit"
                        className="border-gray-900 border-2 text-gray-600 rounded-md px-4 py-2 text-sm font-semibold disabled:opacity-50"
                        disabled={loading}
                    >
                        Einladen
                    </button>
                </form>
                <div>
                    <h3 className="font-semibold mb-2">Eingeladene Nutzer</h3>
                    {invites.length === 0 && <div className="text-gray-500 text-sm">Noch keine Einladungen versendet.</div>}
                    <ul className="flex flex-col gap-2">
                        {invites.map(invite => (
                            <li key={invite.id} className="flex items-center justify-between border-b pb-1">
                                <span>{invite.email}</span>
                                <button
                                    className="text-red-600 hover:text-red-800 ml-2"
                                    onClick={() => handleRevoke(invite.id)}
                                    title="Zugriff entziehen"
                            >
                                <FaTrash />
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
